/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminPermissionModel,
  AdminUserLoggedInResponse,
  AppModel,
  ExchangeTokenModel,
  ExchangeTokenResponse,
  LoginModel,
  MagicLinkRequestedResponse,
  ProblemDetails,
  RequestMagicLinkModel
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




/**
 * @summary Gets app data for the current session.
 */
export const index = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<AppModel>(
      {url: `/api/v1/app`, method: 'GET', signal
    },
      );
    }
  



export const getIndexQueryKey = () => {
    return [
    `/api/v1/app`
    ] as const;
    }

    
export const getIndexQueryOptions = <TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIndexQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof index>>> = ({ signal }) => index(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData> & { queryKey: QueryKey }
}

export type IndexQueryResult = NonNullable<Awaited<ReturnType<typeof index>>>
export type IndexQueryError = ErrorType<void>


/**
 * @summary Gets app data for the current session.
 */

export function useIndex<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getIndexQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Initiates login process for admin users.
 */
export const login = (
    loginModel: LoginModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<AdminUserLoggedInResponse>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginModel, signal
    },
      );
    }
  


export const getLoginMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginModel}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginModel}> = (props) => {
          const {data} = props ?? {};

          return  login(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginModel
    export type LoginMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Initiates login process for admin users.
 */
export const useLogin = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginModel},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }
    /**
 * @summary Get's the current user's admin permissions.
 */
export const getAdminPermissions = (
    
 signal?: AbortSignal
) => {
      
      
      return customAxios<AdminPermissionModel[]>(
      {url: `/api/v1/auth/permissions`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminPermissionsQueryKey = () => {
    return [
    `/api/v1/auth/permissions`
    ] as const;
    }

    
export const getGetAdminPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPermissions>>> = ({ signal }) => getAdminPermissions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPermissions>>>
export type GetAdminPermissionsQueryError = ErrorType<ProblemDetails>


/**
 * @summary Get's the current user's admin permissions.
 */

export function useGetAdminPermissions<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Initiates login process for admin users via email verification and magic link.
 */
export const loginByEmail = (
    requestMagicLinkModel: RequestMagicLinkModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<MagicLinkRequestedResponse>(
      {url: `/api/v1/auth/request-magic-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestMagicLinkModel, signal
    },
      );
    }
  


export const getLoginByEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginByEmail>>, TError,{data: RequestMagicLinkModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof loginByEmail>>, TError,{data: RequestMagicLinkModel}, TContext> => {

const mutationKey = ['loginByEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginByEmail>>, {data: RequestMagicLinkModel}> = (props) => {
          const {data} = props ?? {};

          return  loginByEmail(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type LoginByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof loginByEmail>>>
    export type LoginByEmailMutationBody = RequestMagicLinkModel
    export type LoginByEmailMutationError = ErrorType<unknown>

    /**
 * @summary Initiates login process for admin users via email verification and magic link.
 */
export const useLoginByEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginByEmail>>, TError,{data: RequestMagicLinkModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof loginByEmail>>,
        TError,
        {data: RequestMagicLinkModel},
        TContext
      > => {
      return useMutation(getLoginByEmailMutationOptions(options));
    }
    /**
 * @summary Records the acting admin switching into (or first entering) a platform, stamping it as
their last-used platform. The admin portal calls this when the platform switcher changes
platforms; login-attempt events then carry the resulting last-used platform.
 */
export const switchPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/auth/platforms/${platformId}/switch`, method: 'POST', signal
    },
      );
    }
  


export const getSwitchPlatformMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchPlatform>>, TError,{platformId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof switchPlatform>>, TError,{platformId: string}, TContext> => {

const mutationKey = ['switchPlatform'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchPlatform>>, {platformId: string}> = (props) => {
          const {platformId} = props ?? {};

          return  switchPlatform(platformId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SwitchPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof switchPlatform>>>
    
    export type SwitchPlatformMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Records the acting admin switching into (or first entering) a platform, stamping it as
their last-used platform. The admin portal calls this when the platform switcher changes
platforms; login-attempt events then carry the resulting last-used platform.
 */
export const useSwitchPlatform = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchPlatform>>, TError,{platformId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof switchPlatform>>,
        TError,
        {platformId: string},
        TContext
      > => {
      return useMutation(getSwitchPlatformMutationOptions(options));
    }
    /**
 * @summary Completes magic-link login by exchanging the emailed token for an admin auth token.
 */
export const exchangeToken = (
    exchangeTokenModel: ExchangeTokenModel,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ExchangeTokenResponse>(
      {url: `/api/v1/auth/exchange-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exchangeTokenModel, signal
    },
      );
    }
  


export const getExchangeTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,{data: ExchangeTokenModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,{data: ExchangeTokenModel}, TContext> => {

const mutationKey = ['exchangeToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeToken>>, {data: ExchangeTokenModel}> = (props) => {
          const {data} = props ?? {};

          return  exchangeToken(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ExchangeTokenMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeToken>>>
    export type ExchangeTokenMutationBody = ExchangeTokenModel
    export type ExchangeTokenMutationError = ErrorType<unknown>

    /**
 * @summary Completes magic-link login by exchanging the emailed token for an admin auth token.
 */
export const useExchangeToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,{data: ExchangeTokenModel}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof exchangeToken>>,
        TError,
        {data: ExchangeTokenModel},
        TContext
      > => {
      return useMutation(getExchangeTokenMutationOptions(options));
    }
    